import React from 'react';
import { UuidGenerator } from '../components/uuid-generator/UuidGenerator';

const UuidGeneratorPage: React.FC = () => {
  return <UuidGenerator />;
};

export default UuidGeneratorPage;
